import i18n from 'i18n'
import * as React from 'react'
import { SelectAjaxSeeker } from 'ui-seeker/core'
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { SelectLoading } from "app/components/loading"
import { COMPETITION_URL } from 'app/@common/constants'


export default function SelectDevice({ section, ...props }) {

    if ((section !== 'packages' && section !== 'schedulers') && (!props.sites || !props.date || !props.occupancy || !props.nights)) return <SelectLoading />

    const myProps = {
        urlAjax: COMPETITION_URL.DEVICES,
        placeholder: i18n.t('common:filters.allDevices'),
        icon: { icon: 'phone-laptop' },
        isMulti: true,
        firstSelect: true, 
        isClearable: false, 
        closeMenuOnSelect: false,
        extraParams: {
            id_site: props.sites,
            occupancy: props.occupancy,
            nights: props.nights,
            dateRange: props.date,
            ...props.refresh && { refresh_cache: props.refresh },
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...props.date === 'custom' && { 
                startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
            }
        },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}
